import {
  IconMetroMsk16,
  IconMetroSpb16,
  IconMetroNovosib16,
  IconMetroKzn16,
  IconMetroSam16,
  IconMetroEkb16,
  IconMetroNN16,
} from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './UndergroundIcon.css';

export interface IUndergroundIconProps {
  color: string;
  regionId?: number;
}

export const UndergroundIcon: React.FunctionComponent<React.PropsWithChildren<IUndergroundIconProps>> = ({
  color,
  regionId,
}) => {
  const Icon = React.useMemo(() => {
    switch (regionId) {
      case -1: // Москва и область
      case 1: // Москва
      case 4593: // Московская область
        return IconMetroMsk16;
      case -2: // СПб и область
      case 2: // СПб
      case 4588: // Ленинградская область
        return IconMetroSpb16;
      case 4612: // Свердловская область
      case 4743: // Екатеринбург
        return IconMetroEkb16;
      case 4618: // республика Татарстан
      case 4777: // Казань
        return IconMetroKzn16;
      case 4598: // Новосибирская область
      case 4897: // Новосибирск
        return IconMetroNovosib16;
      case 4608: // Самарская область
      case 4966: // Самара
        return IconMetroSam16;
      case 4596: // Нижегородская область
      case 4885: // Нижний Новгород
        return IconMetroNN16;
      default:
        return IconMetroMsk16;
    }
  }, [regionId]);

  return (
    <span className={styles['icon']} style={{ color }}>
      <Icon color="current_color" />
    </span>
  );
};
